<template>
<div class="card">
    <loading :active.sync="retrieveGroupListLoading" 
        :can-cancel="true"
        :is-full-page="false"></loading>
    <div class="card-header device-title">
        <h3>
          <i class="fas fa-desktop"> Kakao Authority Group</i>
        </h3> 
    </div> 
    
    <div class="card-body">
        <div class="d-flex">
            <button type="button" class="btn btn-green flex-grow-0" v-on:click="showGroupPopup()">Group 생성</button>
        </div>
        <table class="table table-hover table-striped table-light table-bordered mt-2 shadow-sm">
            <thead class="">
                <tr class="text-center device-table-header">
                    <th>그룹명</th>
                    <th>User</th>
                    <th>Authority</th>
                    <th>그룹 설명</th>
                    <th>자세히</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="group in groupList">
                    <td>{{ group.groupId }}</td>
                    <td>{{ group.userCount }}</td>
                    <td>{{ group.authorityCount }}</td>
                    <td>{{ group.description }}</td>
                    <td class="text-center">
                    <button type="button" class="btn btn-blue" @click="showGroupPopup(group)">Detail</button>
                    </td>
                </tr>
                <tr v-show="groupList.length == 0">
                    <td class="text-center" colspan="5">결과가 없습니다.</td>
                </tr>
            </tbody>
        </table>
    </div> <!--card-body-->
    <!--Detail modal start-->
    <b-modal size="xl" ref="modalRequestGroup" header-class="detail-header" title="Authority Group Information" ok-only ok-variant="secondary" ok-title="Close"> <!-- size = xl, lg, sm -->
        <loading :active.sync="requestGroupLoading" 
            :can-cancel="false" 
            :is-full-page="false"></loading>
        <table class="table table-striped table-bordered table-hover shadow-sm mt-2">
            <tbody>
                <tr>
                    <td>그룹명 *</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <input class="form-control" placeholder="그룹명" name="groupId" v-model="groupId" v-validate="'required'" :disabled="existentGroup">
                            <div class="alert-danger" v-if="submitted && errors.has('groupId')">{{ errors.first('groupId') }}</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>그룹 설명 *</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <input class="form-control" maxlength="256" placeholder="그룹 설명" name="description" v-model="description" v-validate="'required'" />
                            <div class="alert-danger" v-if="submitted && errors.has('description')">{{ errors.first('description') }}</div>
                        </div>
                    </td>
                </tr>            
            </tbody>
        </table>
        <table class="table table-striped table-bordered table-hover shadow-sm mt-2">
            <thead class="script-header" >
                <tr class="text-center">
                    <th colspan='2'>User</th>
                    <th colspan='2'>Authority</th>
                </tr>
                <tr class="text-center">
                    <th>전체 <button class="btn btn-sm btn-blue" v-on:click="addAllUsersToGroup()"> >> </button></th>
                    <th><button class="btn btn-sm btn-blue" v-on:click="removeAllUsersFromGroup()"> << </button> 그룹</th>
                    <th>전체 <button class="btn btn-sm btn-blue" v-on:click="addAllAuthoritiesToGroup()"> >> </button></th>
                    <th><button class="btn btn-sm btn-blue" v-on:click="removeAllAuthoritiesFromGroup()"> << </button> 그룹</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <ul v-for="user in nonGroupUsers">
                            <!-- <li @click="addUserToGroup(user.userId)"> {{ user.userId }} ({{ user.role }})</li> -->
                            <li @click="addUserToGroup(user.userId)"> {{ user.userId }} </li>
                        </ul>
                    </td>
                    <td>
                        <ul v-for="user in groupUsers">
                            <li @click="removeUserFromGroup(user.userId)"> {{ user.userId }}</li>
                        </ul>
                    </td>
                    <td>
                        <ul v-for="authority in nonGroupAuthorities">
                            <li @click="addAuthorityToGroup(authority.authorityName)"> {{ authority.authorityName }} ({{ authority.authorityId }})</li>
                        </ul>
                    </td>
                    <td>
                        <ul v-for="authority in groupAuthorities">
                            <li @click="removeAuthorityFromGroup(authority.authorityName)"> {{ authority.authorityName }} ({{ authority.authorityId }})</li>
                        </ul>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="text-center pb-2">
            <button type="button" class="btn btn-green" v-on:click="requestGroup()">{{ existentGroup ? 'Update' : 'Create' }}</button>
            &nbsp;&nbsp;&nbsp;
            <button v-show="existentGroup == false" type="button" class="btn btn-red" v-on:click="resetRequestForm()">Reset</button>
            <button v-show="existentGroup == true" type="button" class="btn btn-red" v-on:click="deleteGroup()">Delete</button>
        </div>
    </b-modal>
    <!--Detail modal end -->
<!--Message Modal-->
    <b-modal id="messageModal" header-class="fail-header" title="Message" ok-only ok-variant="secondary" ok-title="Close">
        <p class="my-4 text-center">{{ msgContent }}</p>
    </b-modal>   
</div> <!--card-->   

</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: 'KakaoGroup',
    data() {
        return {
            groupList: [],  // retrieveGroupList의 결과
            total: 0,  // WorkMan에 있는 group의 총 개수 (특별히 사용하는 곳은 없음)

            existentGroup: false,  // 이미 있는 Group 여부 (있으면 수정/삭제가 가능, 없으면 신규 요청이 가능)

            // 신청(createGroup, updateGroup) 팝업에서 사용
            groupId: '',
            description: '',

            // 시스템에서 관리하는 전체 사용자 및 Peon (권한 문제 때문에 $store 것을 사용할 수 없음)
            allUsers: [],  // [{ 'userId':..., 'role':... }]
            allPeons: [],  // [{ 'deviceId':..., 'alias':... }]
            allAuthorities: [],  // [{ 'deviceId':..., 'alias':... }]

            groupUsers: [],  // [{ 'userId':..., 'role':... }]
            groupPeons: [],  // [{ 'deviceId':..., 'alias':... }]
            groupAuthorities: [],  // [{ 'deviceId':..., 'alias':... }]

            nonGroupUsers: [],  // allUsers에서 groupUsers를 뺀 나머지
            nonGroupPeons: [],
            nonGroupAuthorities: [],

            submitted: false,  // true가 되면 validate 를 진행함
            retrieveGroupListLoading: false,  // GROUP 리스트를 보여주는 곳의 로딩바
            requestGroupLoading: false,  // GROUP 신청 폼에서 보여주는 로딩바
            msgStatus: '',  // alert popup 의 status 인데 사용하진 않고, 아래 content는 보여줌
            msgContent: ''
        }
    },
    components: {
        Loading
    },
    computed: {
        authorityList: function() {
            return this.$store.getters.getAuthorityList;
        }
    },
    methods: {
        showMessage(status, message) {
            this.msgStatus = status;
            this.msgContent = message;
            
            this.$bvModal.show('messageModal');
        },
        addUserToGroup(userId) {
            var index = this.nonGroupUsers.findIndex((item) => { return item.userId === userId });

            // if ('Administrator' == this.nonGroupUsers[index].role) {
            //    this.showMessage(null, '관리자는 그룹에 추가할 필요가 없습니다.');

            //    return;
            // }

            this.groupUsers.push(this.nonGroupUsers[index]);
            this.nonGroupUsers.splice(index, 1);

            //this.groupUsers.sort((a, b) => { return a.role < b.role ? -1 : a.role > b.role  ? 1 : a.userId < b.userId ? -1 : a.userId > b.userId ? -1 : 0; });
            this.groupUsers.sort((a, b) => { return a.userId < b.userId ? -1 : a.userId > b.userId ? -1 : 0; });
        },
        removeUserFromGroup(userId) {
            var index = this.groupUsers.findIndex((item) => { return item.userId === userId });

            this.nonGroupUsers.push(this.groupUsers[index]);
            this.groupUsers.splice(index, 1);

            //this.nonGroupUsers.sort((a, b) => { return a.role < b.role ? -1 : a.role > b.role  ? 1 : a.userId < b.userId ? -1 : a.userId > b.userId ? -1 : 0; });
            this.nonGroupUsers.sort((a, b) => { return a.userId < b.userId ? -1 : a.userId > b.userId ? -1 : 0; });
        },
        addAuthorityToGroup(authorityName) {
            var index = this.nonGroupAuthorities.findIndex((item) => { return item.authorityName === authorityName });

            this.groupAuthorities.push(this.nonGroupAuthorities[index]);
            this.nonGroupAuthorities.splice(index, 1);

            this.groupAuthorities.sort((a, b) => { return a.authorityName < b.authorityName ? -1 : a.authorityName > b.authorityName  ? 1 : a.authorityId < b.authorityId ? -1 : a.authorityId > b.authorityId ? -1 : 0; });
        },
        removeAuthorityFromGroup(authorityName) {
            var index = this.groupAuthorities.findIndex((item) => { return item.authorityName === authorityName });

            this.nonGroupAuthorities.push(this.groupAuthorities[index]);
            this.groupAuthorities.splice(index, 1);

            this.nonGroupAuthorities.sort((a, b) => { return a.authorityName < b.authorityName ? -1 : a.authorityName > b.authorityName  ? 1 : a.authorityId < b.authorityId ? -1 : a.authorityId > b.authorityId ? -1 : 0; });
        },
        addAllUsersToGroup() {
            this.groupUsers = [];
            this.nonGroupUsers = [];

            // this.allUsers.forEach((user) => {
            //     // if (user.role !== 'Administrator') {
            //     //     this.groupUsers.push(user);
            //     // } else {
            //     //     this.nonGroupUsers.push(user);
            //     // }
            //     this.nonGroupUsers.push(user);
            // });

            //this.nonGroupUsers.sort((a, b) => { return a.role < b.role ? -1 : a.role > b.role  ? 1 : a.userId < b.userId ? -1 : a.userId > b.userId ? -1 : 0; });
            //this.groupUsers.sort((a, b) => { return a.role < b.role ? -1 : a.role > b.role  ? 1 : a.userId < b.userId ? -1 : a.userId > b.userId ? -1 : 0; });
            this.nonGroupUsers.sort((a, b) => { return a.userId < b.userId ? -1 : a.userId > b.userId ? -1 : 0; });
            this.groupUsers.sort((a, b) => { return a.userId < b.userId ? -1 : a.userId > b.userId ? -1 : 0; });
        },
        removeAllUsersFromGroup() {
            this.groupUsers = [];
            this.nonGroupUsers = [];

            this.allUsers.forEach((user) => {
                this.nonGroupUsers.push(user);
            });

            //this.nonGroupUsers.sort((a, b) => { return a.role < b.role ? -1 : a.role > b.role  ? 1 : a.userId < b.userId ? -1 : a.userId > b.userId ? -1 : 0; });
            this.nonGroupUsers.sort((a, b) => { return a.userId < b.userId ? -1 : a.userId > b.userId ? -1 : 0; });
        },
        addAllAuthoritiesToGroup() {
            this.groupAuthorities = [];
            this.nonGroupAuthorities = [];

            this.allAuthority.forEach((authority) => {
                this.groupAuthorities.push(authority);
            });

            this.groupAuthorities.sort((a, b) => { return a.authorityName < b.authorityName ? -1 : a.authorityName > b.authorityName  ? 1 : a.authorityId < b.authorityId ? -1 : a.authorityId > b.authorityId ? -1 : 0; });
        },
        removeAllAuthoritiesFromGroup() {
            this.groupAuthorities = [];
            this.nonGroupAuthorities = [];

            this.allAuthorities.forEach((authority) => {
                this.nonGroupAuthorities.push(authority);
            });

            this.nonGroupAuthorities.sort((a, b) => { return a.authorityName < b.authorityName ? -1 : a.authorityName > b.authorityName  ? 1 : a.authorityId < b.authorityId ? -1 : a.authorityId > b.authorityId ? -1 : 0; });
        },
        showGroupPopup(group) {
            this.groupUsers = [];
            this.groupAuthorities = [];

            this.nonGroupUsers = [];
            this.nonGroupAuthorities = [];

            this.allUsers.forEach((user) => {
                this.nonGroupUsers.push(user);
            });

            this.allAuthorities.forEach((authority) => {
                this.nonGroupAuthorities.push(authority);
            });

            if (group == null) {
                this.existentGroup = false;

                this.groupId = '';
                this.description = '';
            } else {
                this.existentGroup = true;

                this.groupId = group.groupId;
                this.description = group.description;

                this.groupUsers = [];
                this.groupAuthorities = [];

                var params = {
                    'groupId': this.groupId
                };

                this.requestGroupLoading = true;
                axios.get('peon/retrieveKakaoGroup', {
                    params: params,
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': accessToken()
                    }
                }).then(response => {  // 이 response는 WorkMan이 status를 0으로 보낸 경우만 해당됨 (나머지 status가 0이 아닌 논리 오류는 main.js에서 이미 error로 보내도록 되어 있음)
                    this.description = response.data.body.description;  // 혹시 바꼈을지도 모르니까..

                    this.nonGroupUsers = [];
                    this.nonGroupAuthorities= [];

                    this.allUsers.forEach((user) => {
                        var index = response.data.body.users.findIndex((item) => { return item === user.userId });
                        if (index < 0) {
                            this.nonGroupUsers.push(user);
                        } else {
                            this.groupUsers.push(user);
                        }
                    });

                    this.allAuthorities.forEach((authority) => {
                        var index = response.data.body.devices.findIndex((item) => { return item === authority.authorityName });
                        if (index < 0) {
                            this.nonGroupAuthorities.push(authority);
                        } else {
                            this.groupAuthorities.push(authority);
                        }
                    });

                    this.groupUsers.sort((a, b) => { return a.role < b.role ? -1 : a.role > b.role  ? 1 : a.userId < b.userId ? -1 : a.userId > b.userId ? -1 : 0; });
                    this.nonGroupUsers.sort((a, b) => { return a.role < b.role ? -1 : a.role > b.role  ? 1 : a.userId < b.userId ? -1 : a.userId > b.userId ? -1 : 0; });
                    this.groupAuthorities.sort((a, b) => { return a.authorityName < b.authorityName ? -1 : a.authorityName > b.authorityName  ? 1 : a.authorityId < b.authorityId ? -1 : a.authorityId > b.authorityId ? -1 : 0; });
                    this.nonGroupAuthorities.sort((a, b) => { return a.authorityName < b.authorityName ? -1 : a.authorityName > b.authorityName  ? 1 : a.authorityId < b.authorityId ? -1 : a.authorityId > b.authorityId ? -1 : 0; });
                }).catch(error => {
                    if (error.status != 401) {
                        this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                    }
                }).finally(() => {
                    this.requestGroupLoading = false;
                });
            }


            this.$refs['modalRequestGroup'].show();
        },
        reloadRetrieveGroupList() {
            this.groupList = [];

            this.retrieveGroupList();
        },
        retrieveGroupList() {
            this.retrieveGroupListLoading = true;
           
            axios.get('peon/retrieveKakaoGroupList', {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {  // 이 response는 WorkMan이 status를 0으로 보낸 경우만 해당됨 (나머지 status가 0이 아닌 논리 오류는 main.js에서 이미 error로 보내도록 되어 있음)
                this.submitted = false;

                this.groupList = response.data.body.list;

                this.total = response.data.body.total;
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.retrieveGroupListLoading = false;
            });
        },
        requestGroup() {
            this.submitted = true;

            this.$validator.validate().then(valid => {
                if (valid) {
                    this.requestGroupLoading = true;

                    var users = [];
                    var authorities = [];
                    this.groupUsers.forEach((item) => { users.push(item.userId); });
                    this.groupAuthorities.forEach((item) => { authorities.push(item.authorityName); });

                    var params = {
                        'groupId': this.groupId,
                        'description': this.description.trim(),
                        'users': users,
                        'authorities': authorities
                    };

                    // 생성 수정 모두 upsertGroup을 사용함 (User, Device 추가해야 하니까..)
                    axios.post('peon/upsertKakaoGroup', params, {
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': accessToken()
                        }
                    }).then(response => {  // 이 response는 WorkMan이 status를 0으로 보낸 경우만 해당됨 (나머지 status가 0이 아닌 논리 오류는 main.js에서 이미 error로 보내도록 되어 있음)
                        this.submitted = false;

                        this.reloadRetrieveGroupList();

                        this.$refs['modalRequestGroup'].hide();

                        this.showMessage(0, this.existentGroup ? "Group이 수정되었습니다." : "Group이 생성되었습니다.");
                    }).catch(error => {
                        if (error.status != 401) {
                            this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                        }
                    }).finally(() => {
                        this.requestGroupLoading = false;
                    });
                }
            });
        },
        deleteGroup() {
            this.submitted = false;

            // loading 이름이 좀 그렇지만, 이대로 재활용..
            this.requestGroupLoading = true;
           
            var params = {
                'groupId': this.groupId
            };

            axios.get('peon/deleteKakaoGroup', {
                params: params,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {  // 이 response는 WorkMan이 status를 0으로 보낸 경우만 해당됨 (나머지 status가 0이 아닌 논리 오류는 main.js에서 이미 error로 보내도록 되어 있음)
                this.reloadRetrieveGroupList();

                this.$refs['modalRequestGroup'].hide();

                this.showMessage(0, "Group 삭제가 완료되었습니다.");
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.requestGroupLoading = false;
            });
        }
    },
    created() {
        this.retrieveGroupList();

        var that = this;

        this.$store.dispatch('retrieveKakaoUserList').then(() => {
            
            that.allUsers = [];

            that.$store.getters.getKakaoUserList.forEach((item, index, array) => {
                //if(!that.allUsers.includes(item.email)){
                    that.allUsers.push({ 'userId': item.email});
                //}
                
            });
            //동일한 이메일 계정 중복 제거
            that.allUsers = [...new Set(that.allUsers.map(JSON.stringify))].map(JSON.parse);

            that.allUsers.sort((a, b) => { return a.userId < b.userId ? -1 : a.userId > b.userId ? -1 : 0; });
        });

        this.$store.dispatch('retrieveKakaoAuthorityList').then(() => {
            that.allAuthorities = [];
            
            that.$store.getters.getAuthorityList.forEach((item, index, array) => {
                that.allAuthorities.push({ 'authorityId': item.authorityId, 'authorityName': item.authorityName });
            });
           
            that.allAuthorities.sort((a, b) => { return a.authorityName < b.authorityName ? -1 : a.authorityName > b.authorityName  ? 1 : a.authorityId < b.authorityId ? -1 : a.authorityId > b.authorityId ? -1 : 0; });
        });
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
